var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      key: _vm.session,
      attrs: {
        visible: _vm.isVisible,
        title: _vm.title,
        "before-close": _vm.beforeClose,
        "show-close": true,
      },
      on: { close: _vm.hide },
    },
    [
      _c("div", { staticClass: "call-dialog" }, [
        _c(
          "div",
          { staticClass: "call-dialog__body" },
          [
            _c(
              "el-row",
              { staticClass: "call-participants", attrs: { gutter: 20 } },
              [
                _c(
                  "el-col",
                  { attrs: { span: 10 } },
                  [
                    _c("call-part", {
                      staticClass: "call-participants__item",
                      attrs: {
                        conversation: _vm.conversation,
                        direction: _vm.direction,
                        role: _vm.getRole("caller"),
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 4 } }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "call-participants__item call-participants__item_center",
                    },
                    [
                      _c("div", { staticClass: "call-participants__arrow" }, [
                        _c("i", { staticClass: "fas fa-chevron-right fa-3x" }),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { span: 10 } },
                  [
                    _c("call-part", {
                      staticClass: "call-participants__item",
                      attrs: {
                        conversation: _vm.conversation,
                        direction: _vm.direction,
                        role: _vm.getRole("callee"),
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "call-dialog__footer" },
          [
            _vm.canAccept
              ? _c(
                  "el-tooltip",
                  {
                    attrs: {
                      effect: "light",
                      placement: "top",
                      content: "Accept",
                    },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-success btn_call",
                        on: {
                          click: function ($event) {
                            return _vm.accept({})
                          },
                        },
                      },
                      [_c("i", { staticClass: "fas fa-phone-alt" })]
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.canReject
              ? _c(
                  "el-tooltip",
                  {
                    attrs: {
                      effect: "light",
                      placement: "top",
                      content: "Reject",
                    },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-danger btn_call",
                        on: {
                          click: function ($event) {
                            return _vm.reject({})
                          },
                        },
                      },
                      [_c("i", { staticClass: "fas fa-phone-slash" })]
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.canHangup
              ? _c(
                  "el-tooltip",
                  {
                    attrs: {
                      effect: "light",
                      placement: "top",
                      content: "Hangup",
                    },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-danger btn_call",
                        on: {
                          click: function ($event) {
                            return _vm.hangup({})
                          },
                        },
                      },
                      [_c("i", { staticClass: "fas fa-phone-slash" })]
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.canIgnore
              ? _c(
                  "el-tooltip",
                  {
                    attrs: {
                      effect: "light",
                      placement: "top",
                      content: "Ignore",
                    },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary btn_call",
                        on: {
                          click: function ($event) {
                            return _vm.ignore({})
                          },
                        },
                      },
                      [_c("i", { staticClass: "fas fa-eye-slash" })]
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.canSendVoiceMail
              ? _c(
                  "el-tooltip",
                  {
                    attrs: {
                      effect: "light",
                      placement: "top",
                      content: "Play Voice Message",
                    },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary btn_call",
                        on: {
                          click: function ($event) {
                            return _vm.toggleVoiceMessages()
                          },
                        },
                      },
                      [_c("i", { staticClass: "fas fa-voicemail" })]
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isFooterVisible,
                expression: "isFooterVisible",
              },
            ],
            staticClass: "call-dialog__collapse",
          },
          [
            _vm.isOutbound
              ? _c("voice-messages", {
                  staticClass:
                    "voice-message-pick-list p-1 border border-gray-300",
                  attrs: { url: _vm.voiceMessagesUrl },
                  on: { "loaded-data": _vm.onVoiceMailItemsLoaded },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }